// import PropTypes from "prop-types";
// import { FormControl, Select, MenuItem } from "@mui/material";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// function StatusFilterSelect({ value, onChange }) {
//   return (
//     <FormControl
//       sx={{
//         minWidth: { xs: "100%", sm: 120 },
//         width: { xs: "100%", sm: 120 },
//         height: "45px",
//         cursor: "pointer",
//         mr: "10px",
//       }}
//     >
//       <Select
//         value={value}
//         onChange={onChange}
//         displayEmpty
//         IconComponent={KeyboardArrowDownIcon}
//         MenuProps={{
//           PaperProps: {
//             sx: {
//               borderRadius: "8px",
//               mt: 0.5,
//               boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
//             },
//           },
//         }}
//         sx={{
//           width: "100%",
//           height: "25px",
//           fontSize: "14px",
//           fontWeight: 600,
//           cursor: "pointer",
//           backgroundColor: "#3DC2EB0D",
//           borderRadius: "8px",
//           color: "#1A1C1C",
//           borderWidth: "1px",
//           "& .MuiOutlinedInput-root": {
//             height: "25px",
//             cursor: "pointer",
//           },
//           "& .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#acb3bd",
//           },
//           "&:hover .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#acb3bd",
//           },
//           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#3DC2EB",
//             borderWidth: "1px",
//           },
//           "& .MuiOutlinedInput-input": {
//             height: "25px !important",
//             boxSizing: "border-box",
//           },
//           "& .MuiSelect-select": {
//             height: "25px !important",
//             minHeight: "25px !important",
//             boxSizing: "border-box",
//             display: "flex",
//             fontWeight: 600,
//             alignItems: "left",
//             cursor: "pointer",
//             padding: "0 80px 0 0 !important",
//             width: "100%",
//             // color: "#1A1A1A"
//           },
//           "& .MuiSelect-icon": {
//             display: "block !important",
//             position: "absolute",
//             right: "8px",
//             top: "50%",
//             width: "20px",
//             height: "20px",
//             color: "#1A1C1C",

//             // Keep arrow pointing down
//             transform: "translateY(-50%) !important",

//             // IMPORTANT:
//             // click passes through icon to Select
//             pointerEvents: "none",
//           },

//           // Prevent MUI's default open rotation
//           "& .MuiSelect-iconOpen": {
//             transform: "translateY(-50%) !important",
//           },
//         }}
//       >
//         <MenuItem value="all">All</MenuItem>
//         <MenuItem value="active">Active</MenuItem>
//         <MenuItem value="inactive">Inactive</MenuItem>
//       </Select>
//     </FormControl>
//   );
// }

// StatusFilterSelect.propTypes = {
//   value: PropTypes.string.isRequired,
//   onChange: PropTypes.func.isRequired,
// };

// export default StatusFilterSelect;

import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function StatusFilterSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const selectRef = useRef(null);

  const options = [
    { value: "all", label: "All" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const selectedOption =
    options.find((option) => option.value === value) || options[0];

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onChange({
      target: {
        value: option.value,
      },
    });

    setOpen(false);
  };

  return (
    <div
      ref={selectRef}
      style={{
        position: "relative",
        width: "120px",
        height: "45px",
        marginRight: "10px",
      }}
    >
      {/* Select Box */}
      <div
        onClick={() => setOpen((prev) => !prev)}
        style={{
          width: "100%",
          height: "43px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          position: "relative",
          padding: "0 32px 0 0",
          paddingLeft: "8px",
          paddingRight: "4px",
          backgroundColor: "#3DC2EB0D",
          border: `1px solid ${open ? "#3DC2EB" : "#acb3bd"}`,
          borderRadius: "8px",
          color: "#1A1C1C",
          fontSize: "14px",
          fontWeight: 600,
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        {/* Selected Text */}
        <span
          style={{
            display: "block",
            width: "100%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {selectedOption.label}
        </span>

        {/* Arrow */}
        <KeyboardArrowDownIcon
          sx={{
            position: "absolute",
            right: "7px",
            top: "50%",
            width: "20px",
            height: "20px",
            color: "#1A1C1C",
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        />
      </div>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "42px",
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
            border: "1px solid #acb3bd",
            padding: "4px 0",
            zIndex: 1300,
          }}
        >
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleSelect(option)}
              style={{
                height: "36px",
                padding: "0 12px",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                fontWeight: option.value === value ? 500 : 400,
                color: "#1A1C1C",
                cursor: "pointer",
                backgroundColor:
                  option.value === value ? "#3DC2EB0D" : "transparent",
              }}
              onMouseEnter={(event) => {
                event.currentTarget.style.backgroundColor = "#3DC2EB0D";
              }}
              onMouseLeave={(event) => {
                event.currentTarget.style.backgroundColor =
                  option.value === value ? "#3DC2EB0D" : "transparent";
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

StatusFilterSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StatusFilterSelect;
